import { genUIComponentNotSupportedStyles as s } from "./GenUIComponentNotSupported.styles";
import type { GenUIComponentNotSupportedProps } from "./GenUIComponentNotSupported.types";

export function GenUIComponentNotSupported({ component }: GenUIComponentNotSupportedProps) {
  return (
    <div className={s.root}>
      Unsupported component <span className={s.code}>{component || "(unknown)"}</span>
    </div>
  );
}
